import { createIcon } from '@chakra-ui/react';

export const RefreshIcon = createIcon({
  displayName: 'RefreshIcon',
  viewBox: '0 0 32 32',
  defaultProps: {
    fill: 'none',
    height: '4',
    width: '4',
  },
  path: (
    <path
      d="M16 7C20.9706 7 25 11.0294 25 16C25 20.9706 20.9706 25 16 25C12.3898 25 9.27841 22.8742 7.84473 19.8105L9.65527 18.9629C10.7722 21.35 13.1946 23 16 23C19.866 23 23 19.866 23 16C23 12.134 19.866 9 16 9C13.6221 9 11.5187 10.185 10.2529 12L12 12.001H13V14H9C7.89561 13.9998 7.00006 13.1044 7 12V8H9V10.3428C10.6492 8.30451 13.1717 7 16 7Z"
      fill="currentColor"
    />
  ),
});
